module.exports = __webpack_public_path__ + "static/media/loader.93008c72.svg";